module.exports = __webpack_public_path__ + "img/第3.6ebe1c88.png";